import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FlowBuilderService } from '../../services/flowBuilder/flow-builder.service';
import { stepLocation } from '../../services/flowBuilder/utils/locaction-calculator-interface';
import { ZoomService } from '../../services/flowBuilder/zoom.service';

@Component({
  selector: 'flow-drawer',
  templateUrl: './flow-drawer.component.html',
  styleUrls: ['./flow-drawer.component.scss'],
})
export class FlowDrawerComponent implements OnInit {
  constructor(
    public flowBuilderService: FlowBuilderService,
    public zoomService: ZoomService
  ) {}

  @Input() selectedNode;
  @Input() isScrollZoom;
  @Input() addNewMenu;
  @Input() copyAndMove;
  @Input() pastContextMenu;
  @Input() flow;
  @Input() isModal;

  @Output() resetSelectedNode = new EventEmitter();
  @Output() nodeClick = new EventEmitter();
  @Output() addNewNode = new EventEmitter();
  @Output() goToFlow = new EventEmitter();
  @Output() onNode = new EventEmitter();

  public activeMode: string;

  ngOnInit() {}

  trackBy(index: any, step: stepLocation) {
    if (!step) {
      return null;
    }
    return step.nodeId;
  }

  resetSelectedNodeHandler() {
    this.resetSelectedNode.emit();
  }

  nodeClickHAndler(e) {
    this.nodeClick.emit(e);
  }

  addNewNodeHandler(e, parentId) {
    this.addNewNode.emit({...e, parentId});
  }

  goToFlowHandler(e) {
    this.goToFlow.emit(e);
  }

  onNodeHandler(e) {
    this.onNode.emit(e);
  }
}
